var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"text",staticStyle:{"height":"200px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }